import StaticPageLayout from "../components/layout/StaticPageLayout";

const h2 = "text-[1.1rem] font-semibold text-[var(--pc-ink)] tracking-[-0.02em] mt-10 mb-3 first:mt-0";
const p = "mb-0 last:mb-0";

export default function CgvPage() {
  return (
    <StaticPageLayout
      pageTitle="Conditions Générales de Vente — Prévention Conseil"
      h1="Conditions Générales de Vente"
    >
      <h2 className={h2}>Article 1 — Objet</h2>
      <p className={p}>
        Les présentes conditions générales de vente régissent les prestations de conseil et d'accompagnement au
        montage de dossiers de subvention dans le cadre du dispositif FIPU (Fonds d'investissement dans la prévention
        de l'usure professionnelle), proposées par ECORENO FRANCE, ci-après "le Prestataire".
      </p>

      <h2 className={h2}>Article 2 — Prestations</h2>
      <p className={p}>
        Le Prestataire assure : le diagnostic d'éligibilité de l'entreprise cliente, le montage complet du dossier de
        demande de subvention et le suivi administratif du dossier jusqu'au versement de la subvention par la CARSAT.
      </p>

      <h2 className={h2}>Article 3 — Facturation et paiement</h2>
      <p className={p}>
        Les honoraires du Prestataire sont dus uniquement après encaissement effectif de la subvention par le client.
        Aucune somme n'est exigible avant le versement de la subvention sur le compte du client. Le montant des
        honoraires est fixé dans le contrat de prestation signé entre les parties préalablement à tout engagement.
      </p>

      <h2 className={h2}>Article 4 — Obligations du client</h2>
      <p className={p}>
        Le client s'engage à fournir l'ensemble des documents nécessaires au montage du dossier dans les délais
        convenus, à maintenir ses cotisations URSSAF à jour pendant toute la durée du traitement, et à reverser les
        honoraires convenus dans un délai de 5 jours ouvrés suivant réception de la subvention.
      </p>

      <h2 className={h2}>Article 5 — Limitation de responsabilité</h2>
      <p className={p}>
        Le Prestataire s'engage à mettre en œuvre tous les moyens nécessaires à la constitution d'un dossier conforme.
        Toutefois, la décision d'attribution de la subvention relève exclusivement de la CARSAT. En cas de rejet du
        dossier pour des raisons indépendantes de la volonté du Prestataire, aucun honoraire ne sera dû par le client.
      </p>

      <h2 className={h2}>Article 6 — Droit applicable</h2>
      <p className={p}>
        Les présentes CGV sont soumises au droit français. Tout litige relève de la compétence des tribunaux de
        Marseille.
      </p>
    </StaticPageLayout>
  );
}
